import { CrudList } from '../shared/CrudPage';
import { tenantService, enumLabel } from '@kss/api';
import type { Tenant, TenantCreate, TenantFilter } from '@kss/api';
import { StatusBadge } from '@kss/ui';

export default function AllTenants() {
  return (
    <CrudList<Tenant, TenantCreate, TenantFilter>
      title="All tenants" newLabel="New tenant" service={tenantService}
      idKey="tenantId" labelKey="name" basePath="/panel/tenants"
      columns={[
        { accessor: 'code', title: 'Code', sortable: true, filterable: true, width: 120 },
        { accessor: 'name', title: 'Name', sortable: true, filterable: true },
        { accessor: 'contactEmail', title: 'Email', filterable: true, render: (r) => r.contactEmail ?? '—' },
        { accessor: 'country', title: 'Country', sortable: true, render: (r) => r.country ?? '—' },
        { accessor: 'currency', title: 'Currency', sortable: true, render: (r) => r.currency ?? '—' },
        { accessor: 'timeZone', title: 'Time zone', render: (r) => r.timeZone ?? '—' },
        { accessor: 'status', title: 'Status', sortable: true,
          render: (r) => <StatusBadge status={enumLabel('TenantStatus', typeof r.status === 'number' ? r.status : Number(r.status))} /> },
      ]}
    />
  );
}
